/* AURA Component Registry 4.0 */
window.AuraRegistry = window.AuraRegistry || (() => {
  const components = new Map();
  const initialized = new WeakMap();
  const metrics = [];

  const now = () => performance && performance.now ? performance.now() : Date.now();

  const register = (name, selector, init, options = {}) => {
    components.set(name, { selector, init, options });
    return api;
  };

  const initComponent = (name, root = document) => {
    const component = components.get(name);
    if (!component) return;

    root.querySelectorAll(component.selector).forEach((el) => {
      if (initialized.get(el)?.includes(name)) return;

      const start = now();
      try {
        component.init(el, component.options);
        initialized.set(el, [...(initialized.get(el) || []), name]);
        metrics.push({ name, ms: Math.round(now() - start), ok: true });
      } catch (error) {
        metrics.push({ name, ms: Math.round(now() - start), ok: false, error: String(error) });
        console.warn(`[AURA] Component failed: ${name}`, error);
      }
    });
  };

  const initAll = (root = document) => {
    components.forEach((_, name) => initComponent(name, root));
    document.dispatchEvent(new CustomEvent('aura:registry:ready', { detail: { metrics } }));
  };

  const getMetrics = () => metrics.slice();

  const api = { register, initComponent, initAll, getMetrics, components };
  return api;
})();
